"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _player = _interopRequireDefault(require("@vimeo/player"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Container = _styledComponents.default.div`
  width: 100%;
  height: ${props => `calc(${100 / props.aspectRatio}vw - ${40 / props.aspectRatio}px)`};

  @media (min-width: 768px) {
    height: 100%;
    width: ${props => `calc(${props.aspectRatio * 100}vh - ${props.aspectRatio * 120}px)`};
  }
`;
const ImageContainer = _styledComponents.default.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;
const ImageEl = _styledComponents.default.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition: 0.35s all;
  height: 100%;
  width: 100%;

  &:hover {
    transform: translate3d(-50%, -50%, 0);
  }
`;
const Image = ({
  src,
  srcSet
}) => {
  return _react.default.createElement(ImageContainer, null, _react.default.createElement(ImageEl, {
    src: src,
    srcSet: srcSet
  }));
};
const VideoContainer = _styledComponents.default.div`
  pointer-events: none !important;
  position: relative;
  height: 100%;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
`;
const PosterImageOrVideo = ({
  image,
  videoId
}) => {
  const videoContainerRef = (0, _react.useRef)(null);
  const playerRef = (0, _react.useRef)(null);
  const containerRef = (0, _react.useRef)(null);
  const ratio = image ? (image.responsiveImage || image.fluid)['aspectRatio'] : 16 / 9;
  const fluid = image.responsiveImage || image.fluid;
  (0, _react.useEffect)(() => {
    if (videoId) {
      initVideo();
    }
  }, [videoId]);
  const initVideo = () => {
    if (playerRef.current) {
      playerRef.current.destroy();
    }
    let w, h;
    const ch = window.innerWidth >= 768 ? containerRef.current.offsetHeight : window.innerHeight;
    const cw = window.innerWidth >= 768 ? containerRef.current.offsetWidth : window.innerWidth;
    const wp = cw / ch;
    if (ratio > wp && window.innerWidth >= 768) {
      h = ch;
      w = h * ratio;
    } else {
      w = cw;
      h = w / ratio;
    }
    const vimeoOptions = {
      title: false,
      controls: false,
      byline: false,
      autoplay: true,
      autopause: false,
      muted: true,
      loop: true,
      width: w,
      height: h
    };
    playerRef.current = new _player.default(videoContainerRef.current, {
      id: videoId,
      ...vimeoOptions
    });
    return () => {
      playerRef.current.destroy();
    };
  };
  return _react.default.createElement(Container, {
    aspectRatio: ratio,
    ref: containerRef
  }, videoId && _react.default.createElement(VideoContainer, {
    ref: videoContainerRef
  }), image && !videoId && _react.default.createElement(Image, fluid));
};
var _default = PosterImageOrVideo;
exports.default = _default;
//# sourceMappingURL=PosterImageOrVideo.js.map